<div>
    <app-server-form></app-server-form>
</div>
<div>
    <app-server-list></app-server-list>
</div>

